export function initDataHref() {
	document.querySelectorAll('[data-href]')
		.forEach(el => {
			const href = el.dataset.href;
			el.addEventListener('click', () => window.location = href);
		});
}
